import React, { useEffect, useState } from "react";
import "./SearchContainer.css";
import Button from "../Button/Button";
import { TiPinOutline, TiPin } from "react-icons/ti";
import Container from "../Container/Container";
import { SESSION_STORE, useIndexedDb } from "../../contexts/indexedDb";
import { useTranslation } from "react-i18next";

const SearchContainer = ({ ...props }) => {
	const [pinned, setPinned] = useState(false);
	const { save: saveInCache, lastSessionData } = useIndexedDb();
	const { t } = useTranslation();

	useEffect(() => {
		setPinned(lastSessionData?.pinnedSearchContainer ?? false);
	}, [lastSessionData]);

	async function onPinClick() {
		await saveInCache({ id: SESSION_STORE, pinnedSearchContainer: !pinned }, SESSION_STORE);
	}

	return (
		<div className={`${pinned ? 'search-pinned' : ''}`}>
			<div className={`search-container-wrapper ${props.className || ''}`}>
				<Container className={`${props.containerClassName || ''}`}>
					<div className={`search-container-content-wrapper`}>
						<div className="flex items-center gap-2.5 text-(--textColor)">
							<div className="p-0! [&>svg]:w-[1.3rem]! rounded-[8px] flex justify-center items-center">
								{props.icon}
							</div>
							<h1 className="search-container-title m-0!">{props.title}</h1>
							<button className="pin-button" type="button" onClick={e => onPinClick()}>
								{pinned ? (
									<TiPin />
								) : (
									<TiPinOutline />
								)}
							</button>
						</div>
						<div className="search-container-inputs-wrapper mt-4!">
							{props.children}
							<div className="search-container-buttons-wrapper mt-0!">
								{props.aditionalButton1}
								{props.aditionalButton2}
								{props.aditionalButton3}
								{!props.hideAddButton && (
									<Button
										className="button-blue adicionar-button"
										action="add"
										navigate={props.navigate}
										label={props.buttonLabel}
										onClick={props.onClickAddButton}
									/>
								)}
							</div>
						</div>
					</div>
				</Container >
			</div>
		</div>
	);
};

export default SearchContainer;
